class JoinTeam {
    constructor() {
        this.editAccountAvatar();
        this.joinTeamManagerFormValidation();
        this.initCountrySelect();
    }
    editAccountAvatar(){
        /** Open avatars modal */
        $(document).on('click', '#editJoinTeamManagerAvatarBtn', function(e) {
            new bootstrap.Modal(document.getElementById('change_account_avatar_modal'), {}).show();
        });
        /** Open avatars modal */
        $(document).on('click', '#change_account_avatar_modal .symbol', function(e) {
            let img = $(this).find('img');
            let avatarSrc = (img[0].getAttribute('src')).replace(/ /g, "%20");
            $('#account-avatar').attr('src',avatarSrc);
            $('#frm-joinTeamManagerForm-joinTeamManagerForm input[name="AvatarID"]').val($(this).find('img')[0].getAttribute('data-value'));
            bootstrap.Modal.getInstance(document.getElementById('change_account_avatar_modal')).hide();
        });
    }
    joinTeamManagerFormValidation(){
        let form = document.getElementById('frm-joinTeamManagerForm-joinTeamManagerForm');
        if(form){

            let submitButton = document.getElementById('join_team_manager_form_submit');
            let passwordMeter = KTPasswordMeter.getInstance(form.querySelector('[data-kt-password-meter="true"]'));
            // Password input validation
            const validatePassword = function() {
                return (passwordMeter.getScore() === 100);
            };

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'FirstName': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'First Name cannot be over 64 characters',
                                },
                            }
                        },
                        'LastName': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'Last Name cannot be over 64 characters',
                                },
                            }
                        },
                        'Password': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Password has to be between 8 and 45 characters long',
                                },
                                regexp: {
                                    regexp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.])[A-Za-z\d[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.]{8,45}$/,
                                    message: 'You used a forbidden character',
                                },
                                callback: {
                                    message: 'Please enter valid password',
                                    callback: function() {
                                        return validatePassword();
                                    }
                                }
                            }
                        },
                        'Country': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.attributes.name.value === 'Password'){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
    initCountrySelect(){
        // Format Member results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        // Init Select2
        $('#frm-joinTeamManagerForm-joinTeamManagerForm select[name=Country]').select2({
            placeholder: "Select an option",
            templateSelection: optionFormat,
            templateResult: optionFormat,
        });
    }
}
window.JoinTeam = JoinTeam;